module.exports = __webpack_public_path__ + "static/img/A178.8844ade5.jpg";